import { Panel } from './panel';

export interface SplitPanel extends Panel {
  orientation: 'vertical' | 'horizontal';
  layouts: string[];
}
